import { RectangleAnnotation } from '@st/sdk'
import { THEME_COLORS } from '@st/theme/colors'
import { RectToolState } from '../../annotations'

export const RECT_COLOR_OPTIONS = [
  THEME_COLORS['red'][600],
  THEME_COLORS['blue'][500],
  THEME_COLORS['purple'][500],
  THEME_COLORS['orange'][500],
  THEME_COLORS['green'][500],
  THEME_COLORS['gray'][900]
]

export function copyToolState(annotation: RectangleAnnotation): RectToolState {
  return {
    name: 'rectangle',
    settings: { border: annotation.border }
  }
}
